var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.error.statusCode === 404)?_c('h1',[_vm._v(" "+_vm._s(_vm.pageNotFound)+" ")]):_c('h1',[_vm._v(" "+_vm._s(_vm.otherError)+" ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t("nav.home"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }